var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:currentColor;}")),React.createElement("path",{"className":"a","d":"M18.107,15.493l-4.2-4.2a7.566,7.566,0,0,0,1.027-3.827,7.467,7.467,0,1,0-7.467,7.467,7.566,7.566,0,0,0,3.827-1.027l4.2,4.2a1.848,1.848,0,0,0,2.613-2.613Zm-10.64-3.36A4.621,4.621,0,0,1,2.8,7.467,4.621,4.621,0,0,1,7.467,2.8a4.621,4.621,0,0,1,4.667,4.667A4.621,4.621,0,0,1,7.467,12.133Z","key":1})]);
}

IconSearch.defaultProps = {"width":"18.667","height":"18.667","viewBox":"0 0 18.667 18.667"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
